export const STEP_PATHS = {
  ASSET_GROUP: 'ASSET_GROUP',
  CAMPAIGN_TARGETING: 'CAMPAIGN_TARGETING',
  CAMPAIGN_SETTING: 'CAMPAIGN_SETTING',
};

export const FLOWS = {
  WINDOWS_STORE_APPS: 'WINDOWS_STORE_APPS',
};

export const FLOWS_TO_FIRST_STEP_CAMPAIGN_CREATION = {
  [FLOWS.WINDOWS_STORE_APPS]: STEP_PATHS.ASSET_GROUP,
};

export const FLOWS_TO_FIRST_STEP_CAMPAIGN_EDIT = {
  [FLOWS.WINDOWS_STORE_APPS]: STEP_PATHS.CAMPAIGN_TARGETING,
};

export const FLOWS_TO_FIRST_STEP_ASSET_GROUP = {
  [FLOWS.WINDOWS_STORE_APPS]: STEP_PATHS.ASSET_GROUP,
};
